import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-todo',
  templateUrl: './todo.component.html',
  styleUrls: ['./todo.component.css']
})
export class TodoComponent implements OnInit {
  title = "Priyank Patel";
  myarr = ["C", "C++", "Java"];
  name = "Depple";
  isValid = false;
  count = 0;

  constructor() {

  }

  btn1Click() {
    ++this.count;
  }

  ngOnInit(): void {

  }

}
